// extracted by mini-css-extract-plugin
module.exports = {"slippage":"Slippage-module--slippage--Wf4Hl","title":"Slippage-module--title--2IiP9"};